/**
 * PriorityIndicator — five segments, filled up to `priority`. 5 = критический.
 * Carries text too (number + label) so it's never colour-only (§6).
 */
import type { AnomalyPriority } from "@/types/contract";
import { priorityTone, PRIORITY_LABELS } from "@/lib/anomaly";
import { cn } from "@/lib/utils";

const fillByTone: Record<string, string> = {
  danger: "bg-danger",
  warning: "bg-warning",
  neutral: "bg-muted",
  accent: "bg-accent",
  solid: "bg-primary",
};

export function PriorityIndicator({ priority }: { priority: AnomalyPriority }) {
  const tone = priorityTone(priority);
  const fill = fillByTone[tone] ?? "bg-muted";
  return (
    <div className="flex items-center gap-2" title={`Приоритет ${priority}/5`}>
      <div
        className="flex items-end gap-0.5"
        role="img"
        aria-label={`Приоритет ${priority} из 5: ${PRIORITY_LABELS[priority]}`}
      >
        {([1, 2, 3, 4, 5] as const).map((seg) => (
          <span
            key={seg}
            className={cn(
              "w-1 rounded-full transition-colors",
              seg <= priority ? fill : "bg-border",
            )}
            style={{ height: 6 + seg * 3 }}
          />
        ))}
      </div>
      <span className="tabular text-xs font-semibold text-muted">
        {priority}/5
      </span>
    </div>
  );
}
